import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { getCurrenLang } from '../../redux/selector';
import { InputLoginPassword, InputRedesign } from '../../common/Input';
import { Button } from '../../common/Button/Button';
import styles from './styles.module.css';
import { LoginFormProps } from './types';

export const LoginForm = ({
  errorMessage,
  hasErrors,
  inputValue,
  isTouched,
  onChangeMethod,
}: LoginFormProps): ReactElement => {
  const t: any = useSelector<any>((state) => getCurrenLang(state));
  const sign_in_btn = t?.common.sing_in_submit || 'Sign In';
  const email_t = t?.auth.email || 'Email';
  const password_t = t?.auth.password || 'Password';

  return (
    <div className={styles.form_wrapper}>
      <InputRedesign
        inputId="loginEmail"
        inputName="email"
        inputType="text"
        hasErrors={hasErrors.email}
        inputValue={inputValue.email}
        isTouched={isTouched.email}
        onChangeMethod={onChangeMethod}
        placeholder={email_t}
        disabled={false}
      />
      <InputLoginPassword
        inputId="loginPassword"
        inputName="password"
        hasErrors={hasErrors.password}
        inputValue={inputValue.password}
        isTouched={isTouched.password}
        onChangeMethod={onChangeMethod}
        placeholder={password_t}
        disabled={false}
      />
      {errorMessage && <div className={styles.errorMessage}>{errorMessage}</div>}

      <div className={styles.content}>
        <Button buttonType="submit" buttonName={sign_in_btn} buttonClass={styles.btn__submit} />
      </div>
    </div>
  );
};
